(function(){
  if(location.pathname.indexOf('/pages/agenda') === 0) return;
  function rw(){
    var as = document.querySelectorAll('a[href*="calendly.com"]');
    for(var i=0;i<as.length;i++){ as[i].setAttribute('href','/pages/agenda'); as[i].removeAttribute('target'); }
  }
  if(document.readyState !== 'loading'){ rw(); } else { document.addEventListener('DOMContentLoaded', rw); }
  document.addEventListener('shopify:section:load', rw);
})();

/* ============================================================
   BigStudio · Medición de WhatsApp en Meta   (2026-09-11)
   ------------------------------------------------------------
   Este archivo carga en TODAS las páginas (grupo overlay), así
   que aquí vive el tracking de WhatsApp de todo el sitio:
   el botón flotante (.bs-wa), el de la agenda (.js-wa) y
   cualquier enlace a wa.me.

   Un solo listener delegado = un solo evento por clic. El clic
   a WhatsApp NO se mide en bs-agf.js, justamente para no
   duplicarlo en la página de agenda.
   ============================================================ */
(function () {
  'use strict';

  var PIXEL_ID = '595968475232736';

  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', PIXEL_ID);

  var SELECTOR = '.bs-wa, .js-wa, a[href*="wa.me"], a[href*="api.whatsapp.com"]';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest(SELECTOR)) return;

    var datos = {
      content_name: location.pathname,
      content_category: 'WhatsApp'
    };

    // Si el clic ocurre en la agenda con un plan elegido, lo adjuntamos.
    var plan = document.querySelector('.bs-agf__plan.is-sel');
    if (plan) {
      datos.content_name = plan.getAttribute('data-name') || location.pathname;
      datos.content_category = 'WhatsApp Agenda';
      var clpEl = document.querySelector('.bs-agf__price-clp');
      if (clpEl) {
        var digitos = (clpEl.textContent || '').replace(/\D/g, '');
        if (digitos) { datos.value = parseInt(digitos, 10); datos.currency = 'CLP'; }
      }
    }

    fbq('track', 'Contact', datos);
  }, true);

})();
